module.exports = __webpack_public_path__ + "img/UBP-logo.981f91ba.svg";